import React from 'react';

import { Box, Divider, Menu, MenuItem, Typography } from '@mui/material';

import { IContextMenuProps } from 'src/components/common/types/contextMenuTypes';

const ContextMenu: React.FC<IContextMenuProps> = ({
	open,
	onClose,
	items,
	anchorElement,
	clearAnchorElement,
}: IContextMenuProps): React.JSX.Element => (
	<Menu
		anchorEl={anchorElement}
		anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'right',
		}}
		open={open}
		disableScrollLock={true}
		onClose={onClose}
		sx={{
			'.MuiList-root': {
				paddingY: 0,
			},
		}}
	>
		{items?.map((item, index) => (
			<Box key={index}>
				<MenuItem
					key={index}
					disabled={item.disabled || false}
					onClick={() => {
						item.onClick();
						clearAnchorElement();
					}}
					sx={{ px: 2, py: 1.5 }}
				>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
						{item.icon}
						<Typography
							variant='body2'
							color={item.color ?? 'text.primary'}
							sx={{ fontWeight: 400 }}
						>
							{item.label}
						</Typography>
					</Box>
				</MenuItem>
				{index !== items.length - 1 && (
					<Divider
						sx={{
							marginX: -2,
							marginY: '0px !important',
						}}
					/>
				)}
			</Box>
		))}
	</Menu>
);

export default ContextMenu;
